<template>
    <div :style="{borderLeft: '6px solid '+ (type === 'live' ? ada.pink : ada.blue)}" class="pl-4">
        <transition name="fade" mode="out-in">
            <div :key="0" v-if="loadingJSON" class="d-flex justify-center my-10">
                <v-progress-circular :size="50" :width="3" :color="ada.pink"
                                     indeterminate
                ></v-progress-circular>
            </div>
            <div v-else :key="1">
                <div v-if="site && sitetype">
                    <div class="d-flex justify-space-between">
                        <Input style="max-width:300px" class="ml-4 mr-8" v-model.trim="search_all"
                               :label="sitetype.SitetypeId+'.json durchsuchen'"
                               append-icon="mdi-magnify"></Input>
                        <div>
                            <TooltipIcon :customStyle="{marginRight: '10px'}" :disabled="readOnly"
                                         v-if="vuexState['jsonContent_' + type] ? Object.keys(vuexState['jsonContent_' + type]).length !== 0 : false"
                                         :tooltip="capitalizeFirstLetter(type) + ' ' + sitetype.SitetypeId + '.json löschen'"
                                         fab :color="ada.red" @click="$emit('click:delete', type, {}, 'json')">
                                mdi-delete
                            </TooltipIcon>
                            <TooltipIcon tooltip="Template hinzufügen" :color="ada.blue" fab :disabled="readOnly"
                                         :customStyle="{marginRight: '10px'}"
                                         @click="$emit('click:add-template', null)"
                            >
                                mdi-plus
                            </TooltipIcon>
                            <TooltipIcon tooltip="JSONs vergleichenn" :color="ada.purple" fab
                                         @click="$emit('click:json-compare')" :customStyle="{marginRight: '10px'}"
                            >
                                mdi-file-compare
                            </TooltipIcon>
                            <TooltipIcon
                                :tooltip="capitalizeFirstLetter(type) + ' ' + sitetype.SitetypeId + '.json downloaden'"
                                :color="ada.darkGrey" fab @click="downloadJSON"
                            >
                                mdi-download
                            </TooltipIcon>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap typeContainer">
                        <v-card v-for="(jsonType, i) in uniqueTypes" :key="jsonType"
                                :class="{'mb-4': i+1 !== uniqueTypes.length}"
                                outlined shaped width="100%"
                        >
                            <v-card-title>
                                <span class="mr-8 title">{{ jsonType }}</span>
                                <div>
                                    <Input v-model.trim="search[jsonType.toLowerCase()]" class="input tileSearch"
                                           label="Suche"
                                           append-icon="mdi-magnify"
                                           :hide-details="true"></Input>
                                </div>
                            </v-card-title>
                            <v-card-text class="d-flex flex-wrap" :key="refreshKey">
                                <JsonEntryTile v-for="(entry,j) in getType(jsonType)" :key="'tile_'+j"
                                               :data="entry" :type="type"
                                               class="mr-3 mb-3" @click="$emit('click', entry)"
                                               @click:delete="$emit('click:delete', type, getFinalJson(entry.completeKey), 'entry', entry.completeKey)"
                                ></JsonEntryTile>
                            </v-card-text>
                        </v-card>
                    </div>
                </div>
                <div v-else :style="{minHeight:'30vh'}" class="noSiteSelected">
                    Bitte eine Seite zum Bearbeiten auswählen.
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import ada from "../../scss/ada_colors.scss";
import Utils from "../../scripts/Utils";
import JsonEntryTile from "./components/JsonEntryTile";
import Input from "../../components/Inputs/Input";
import TooltipIcon from "../../components/TooltipIcon";

export default {
    name: "JsonEditorIndex",
    components: {TooltipIcon, Input, JsonEntryTile},
    props: ['type', 'site', 'sitetype'],
    data: () => {
        return {
            ada,
            search_all: '',
            search: {
                'default': '',
                'homepage': '',
                'index': '',
                'bildergalerie': '',
                'artikel': ''
            },
            refreshKey: 0,
        }
    },
    mounted() {
        if (this.vuexState['jsonContent_' + this.type] !== null) {
            this.fetchJson();
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.editor;
        },
        loadingJSON() {
            return this.vuexState.loadingJSON;
        },
        jsonEntries() {
            let ret = [];
            if (this.vuexState['jsonContent_' + this.type]) {
                Object.keys(this.vuexState['jsonContent_' + this.type]).forEach((key) => {
                    ret.push(this.parseJSONKey(key));
                })
            }
            ret = this.getFilteredEntries(ret, this.search_all);
            return ret;
        },
        uniqueTypes() {
            let copy = JSON.parse(JSON.stringify(this.jsonEntries));
            return copy.length !== 0 ? [...new Set(copy.map(x => x.type.name))].sort() : [];
        },
        readOnly() {
            return this.$store.state.readOnly === 1;
        }
    },
    methods: {
        async fetchJson(forced = false) {
            if (this.sitetype && (this.vuexState.jsonContent_live === null || this.vuexState.jsonContent_stage === null || forced) && !this.loadingJSON) {
                let data = await this.$store.dispatch('editor/fetchJSON', this.sitetype.SitetypeId);
                if (typeof data !== "undefined" && data.isAxiosError) {
                    if (data.isAxiosError) {
                        //if (data.config.url.indexOf('https://json-editor.adalliance.io/cache/') === -1) this.$root.$emit('snackbar', this.sitetype.SitetypeId + '.json exisitert nicht', 'error')
                    }
                } else {
                    this.$root.$emit('snackbarOff');
                }
            }
        },
        downloadJSON() {
            let url =  'https://static.emsservice.de.s3-eu-west-1.amazonaws.com/teasertemplates/';
            if (this.type === 'stage') {
                url += `stage/${this.sitetype.SitetypeId}.json`
            } else {
                url += `${this.sitetype.SitetypeId}.json`;
            }

            axios.get(url, {responseType: 'blob'})
            .then(response => {
                const blob = new Blob([response.data], {type: 'application/json'})
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = this.sitetype.SitetypeId + '.json';
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error);
        },
        getFinalJson(deleteKey) {
            let json = JSON.parse(JSON.stringify(this.vuexState['jsonContent_' + this.type]));
            delete json[deleteKey];
            return json;
        },
        getType(jsonType) {
            let ret;
            let entries = JSON.parse(JSON.stringify(this.jsonEntries));
            if (entries.length !== 0) {
                ret = entries.filter(x => x.type.name.toLowerCase() === jsonType.toLowerCase());
                if (this.search[jsonType] !== '') {
                    let searchArr = this.search[jsonType.toLowerCase()].split(' ');
                    let tmp = [];
                    for (let i = 0; i < ret.length; i++) {
                        let entry = ret[i]
                        let matches = true;
                        for (let j = 0; j < searchArr.length; j++) {
                            if (entry.completeKey.toLowerCase().indexOf(searchArr[j]) === -1) {
                                matches = false;
                            }
                        }
                        if (matches) tmp.push(entry);
                    }
                    ret = tmp;
                }
            } else {
                ret = entries;
            }
            return Utils.sortJsonKeys(ret);
        },
        compare(a, b) {
            if (a.completeKey < b.completeKey) {
                return -1;
            }
            if (a.completeKey > b.completeKey) {
                return 1;
            }
            return 0;
        },
        parseJSONKey(key) {
            return Utils.parseJSONKey(key, this.vuexState.types, this.vuexState.teasertypes);
        },
        getFilteredEntries(array, searchValue) {
            let arrCopy = JSON.parse(JSON.stringify(array))
            let tmp = [];
            if (searchValue !== '') {
                let searchArr = searchValue.toLowerCase().split(' ');
                for (let i = 0; i < arrCopy.length; i++) {
                    let entry = arrCopy[i];
                    let matches = true;
                    for (let j = 0; j < searchArr.length; j++) {
                        if (entry.completeKey.toLowerCase().indexOf(searchArr[j]) === -1) {
                            matches = false;
                        }
                    }
                    if (matches) tmp.push(entry);
                }
            } else {
                tmp = arrCopy;
            }
            tmp.sort(Utils.naturalCompare);
            return tmp;
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
    ,
    watch: {
        /*site() {
            this.fetchJson(true);
        },*/
        sitetype() {
            this.fetchJson(true);
        },
        search: {
            handler() {
                this.refreshKey++;
            }
            ,
            deep: true,
        },
    }
}
</script>

<style lang="scss" scoped>

.input {
    position: relative;
    top: -10px;
    font-weight: 400;
}

.typeContainer {

    ::v-deep .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: rgba(0, 0, 0, 0.2);
    }

    ::v-deep .theme--light.v-label {
        color: rgba(0, 0, 0, 0.4);
    }

    ::v-deep .mdi-magnify:before {
        color: rgba(0, 0, 0, 0.2);
    }

}

::v-deep .v-card__title {
    padding: 10px 20px 5px 20px;

    .title {
        font-size: 1.1rem !important;
    }

    .tileSearch {
        padding-top: 7px;

        input {
            padding: 0;
            font-size: 0.9em;
        }

        .v-text-field__slot label {
            top: 2px;
            font-size: 14px;
        }

        .v-text-field__slot label.v-label--active {
            transform: translateY(-15px) scale(0.75);
        }
    }
}

</style>